<template>
    <div id="app">
        <!-- <tools class="tools"></tools> -->
        <router-view/>
    </div>
</template>

<script>
import Tools from "@/components/Tools/index"
export default {
    name: 'App',
    components: {
        Tools
    }
}
</script>
<style scoped>
.tools {
  height: 50px;
  padding: 10px;
}
</style>
<style>
* {
  margin: 0;
  padding: 0;
}
.base-flex {
  display: flex;
}
.-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hover-move {
  cursor: move;
}
.hover-opacity {
  opacity: 0.2;
}
.hover-opacity:hover {
  opacity: 0.7;
  cursor: crosshair;
}
*.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;

  /*
     Introduced in IE 10.
     See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
   */
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue